import ApiProvider from '../../../../../../core/api/ApiProvider';
import { ActionStatusType } from '../../../../../../core/types/ActionStatusType';

const ManualInstallmentPlanApi = {
  CalculateManualInstallmentPlan: async (
    caseId: string,
    installmentAmount: number,
    startDate: string
  ) => {
    return await ApiProvider.get<ActionStatusType>(
      `InstallmentPlanModule/CalculateManualInstallmentPlan?caseId=${caseId}&installmentAmount=${installmentAmount}&startDate=${startDate}`
    );
  },
};

export default ManualInstallmentPlanApi;
